module.exports = __webpack_public_path__ + "static/media/video1.966195be.webm";